__turbopack_context__.v({
  "bruketIWiaredApp": "MainNavbarBrand-module-scss-module__QokVKa__bruketIWiaredApp",
  "brutaleApp": "MainNavbarBrand-module-scss-module__QokVKa__brutaleApp",
  "butchersMarketApp": "MainNavbarBrand-module-scss-module__QokVKa__butchersMarketApp",
  "cornerApp": "MainNavbarBrand-module-scss-module__QokVKa__cornerApp",
  "heatApp": "MainNavbarBrand-module-scss-module__QokVKa__heatApp",
  "kafeMagasinetApp": "MainNavbarBrand-module-scss-module__QokVKa__kafeMagasinetApp",
  "klappenBagerietApp": "MainNavbarBrand-module-scss-module__QokVKa__klappenBagerietApp",
  "klappenHalsterApp": "MainNavbarBrand-module-scss-module__QokVKa__klappenHalsterApp",
  "klappenToppstuganApp": "MainNavbarBrand-module-scss-module__QokVKa__klappenToppstuganApp",
  "lundsKommunApp": "MainNavbarBrand-module-scss-module__QokVKa__lundsKommunApp",
  "morenoPizzaApp": "MainNavbarBrand-module-scss-module__QokVKa__morenoPizzaApp",
  "navBrand": "MainNavbarBrand-module-scss-module__QokVKa__navBrand",
  "nordrestAxisApp": "MainNavbarBrand-module-scss-module__QokVKa__nordrestAxisApp",
  "olandschokladApp": "MainNavbarBrand-module-scss-module__QokVKa__olandschokladApp",
  "strandgatanApp": "MainNavbarBrand-module-scss-module__QokVKa__strandgatanApp",
  "tacosAndTequilaApp": "MainNavbarBrand-module-scss-module__QokVKa__tacosAndTequilaApp",
  "whiteLabeled": "MainNavbarBrand-module-scss-module__QokVKa__whiteLabeled",
});
